import React from 'react';
import HamburgerMenuWithNewSiteNavigation from './HamburgerMenuWithNewSiteNavigation';

export default function HamburgerMenuWithSiteNavigationPicker(props) {
  return <HamburgerMenuWithNewSiteNavigation {...props} />;
}
